export function toE164(input: string): string {
  const trimmed = input.trim()
  const onlyNumbers = trimmed.replace(onlyNumbersRegex[0], onlyNumbersRegex[1])
  return trimmed.substring(0, 1) === '+' ? '+' + onlyNumbers : onlyNumbers
}

const onlyNumbersRegex = [/\D*/g, ''] as const
